// Regex to match 6-digit hex colors (#RRGGBB)
const HEX_COLOR_REGEX = /#[A-Fa-f0-9]{6}/g

/**
 * Detects 6-digit hex colors in text and returns segments with color information
 */
export function parseTextWithColors(text: string): Array<{ text: string; isColor: boolean; hex?: string }> {
  const segments: Array<{ text: string; isColor: boolean; hex?: string }> = []
  let lastIndex = 0
  let match: RegExpExecArray | null

  // Reset regex lastIndex to ensure proper matching
  HEX_COLOR_REGEX.lastIndex = 0

  while ((match = HEX_COLOR_REGEX.exec(text)) !== null) {
    // Add text before the color
    if (match.index > lastIndex) {
      segments.push({
        text: text.slice(lastIndex, match.index),
        isColor: false
      })
    }

    // Add the color segment
    segments.push({
      text: match[0],
      isColor: true,
      hex: match[0]
    })

    lastIndex = match.index + match[0].length
  }

  // Add remaining text after the last color
  if (lastIndex < text.length) {
    segments.push({
      text: text.slice(lastIndex),
      isColor: false
    })
  }

  return segments
}

/**
 * Checks if text contains any 6-digit hex colors
 */
export function containsHexColors(text: string): boolean {
  return HEX_COLOR_REGEX.test(text)
}